// --------------------------------------------------------------
// Created On: 2025-03-14
// Author: Dimitra Weinstein
//
// Last Modified: 2025-03-31
// Modified By: Dimitra Weinstein
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import PropTypes from "prop-types";

// A single report in a list of reports.
export default function MemphisReportListRow(props: Props): Component {
  return (
    <div className="p-2" data-test="memphis-report-list-row">
      <span>{props.name}</span>
    </div>
  );
}

MemphisReportListRow.propTypes = {
  reportMemphisId: PropTypes.number,
  name: PropTypes.string.isRequired,
};

interface Props {
  reportMemphisId: number | null;
  name: string;
}
